<script>
  export default {
    methods: {
      phoneFormater (value) {
        var arr = value.replace(/[^\d]/g, '').split('')
        if (arr.length) arr.unshift('(')
        if (arr.length > 4) arr.splice(4, 0, ') ')
        if (arr.length > 8) arr.splice(8, 0, '-')
        return arr.join('').substring(0, 14)
      },
      dateFormater (value) {
        var arr = value.replace(/[^\d]/g, '').split('')
        if (arr.length > 2) arr.splice(2, 0, '/')
        if (arr.length > 5) arr.splice(5, 0, '/')
        return arr.join('').substring(0, 10)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FormatersMixin.vue?421f25c6